<template>
    <el-dialog
        width="50%"
        :title="type === 'service' ? '服务内容' : '优势内容'"
        :visible.sync="industryVisible"
        append-to-body
    >
        <div id="demo1"></div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="industryVisible = false"
                >确 定</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
export default {
    data() {
        return {
            industryVisible: false,
            // 判断是服务详情还是优势详情
            type: "",
            editor: null,
        };
    },
    mounted() {},
    methods: {
        init(value) {
            this.industryVisible = true;
            this.type = value;
        },
    },
};
</script>

<style lang="less" scoepd>
</style>